import { useEffect, useState } from "react";
import { api, formatEUR } from "../lib/api";
import Layout, { Card, Label, Spinner } from "../components/Layout";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from "recharts";

const COLORS = ["#002FA7", "#8B5CF6", "#10B981", "#F59E0B", "#EF4444", "#64748B"];

export default function Analytics() {
  const [kpis, setKpis] = useState(null);
  useEffect(() => { api.get("/dashboard/kpis").then(({ data }) => setKpis(data)); }, []);
  if (!kpis) return <Layout title="Analytics"><Spinner /></Layout>;

  return (
    <Layout title="Analytics" subtitle="Approfondimenti sul flusso di gare e performance">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Card>
          <Label>Distribuzione importi per portale</Label>
          <div style={{ height: 320 }}>
            <ResponsiveContainer>
              <BarChart data={kpis.by_portal} margin={{ top: 10, right: 10, bottom: 0, left: 30 }}>
                <XAxis dataKey="portal" tick={{ fontSize: 11, fontFamily: "IBM Plex Mono" }} />
                <YAxis tickFormatter={(v) => `${(v / 1000).toFixed(0)}K`} tick={{ fontSize: 11 }} />
                <Tooltip formatter={(v) => formatEUR(v)} contentStyle={{ fontSize: 12 }} />
                <Bar dataKey="value" fill="#002FA7" radius={[2, 2, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Card>

        <Card>
          <Label>Quote percentuali</Label>
          <div style={{ height: 320 }}>
            <ResponsiveContainer>
              <PieChart>
                <Pie data={kpis.by_portal} dataKey="count" nameKey="portal" outerRadius={110} label={(e) => `${e.portal}`}>
                  {kpis.by_portal.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Tooltip contentStyle={{ fontSize: 12 }} />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </Card>
      </div>

      <Card className="mt-4">
        <Label>Riepilogo operativo</Label>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-3">
          <Stat label="Gare totali" value={kpis.total_tenders} />
          <Stat label="Decisioni BID" value={kpis.decided_bid} />
          <Stat label="Decisioni NO-BID" value={kpis.decided_no_bid} />
          <Stat label="Hit rate decisioni" value={kpis.decided_bid + kpis.decided_no_bid > 0 ? `${Math.round(kpis.decided_bid / (kpis.decided_bid + kpis.decided_no_bid) * 100)}%` : "—"} />
        </div>
      </Card>
    </Layout>
  );
}

function Stat({ label, value }) {
  return (
    <div className="border-l-2 border-klein pl-3">
      <div className="label-up">{label}</div>
      <div className="font-display text-3xl font-bold tracking-tighter">{value}</div>
    </div>
  );
}
